import React from 'react';
import { StaticPageHeader } from '../components/StaticPageHeader';
import { Footer } from '../components/Footer';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <StaticPageHeader />

      {/* Add padding top to account for fixed header */}
      <div className="pt-16">
        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: July 1, 2026</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              DriveHR (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website at <a href="https://www.drive-hr.com" className="text-blue-600 hover:underline">www.drive-hr.com</a>, purchase our products, or use our services.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Information We Collect</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Personal data you voluntarily provide (name, email, company name, billing information)</li>
              <li>Automatically collected data (IP address, browser type, device data, site usage via cookies)</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Use of Information</h2>
            <p className="text-gray-700 mb-4">We use collected data to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Process transactions</li>
              <li>Send product updates and support communications</li>
              <li>Improve our website and services</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Sharing Your Information</h2>
            <p className="text-gray-700 mb-6">
              We do not sell or rent your personal information. We share data only with trusted third-party service providers who help us operate our business, under confidentiality and data-protection obligations. These include: Stripe (payment processing and subscription billing); MailerLite (email delivery and marketing communications); Google Workspace (business email and document storage); Meta/Facebook &amp; Instagram (advertising and conversion measurement via the Meta Pixel); Resend (transactional email delivery). These providers process your information only as needed to perform their services for us.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Cookies &amp; Tracking Technologies</h2>
            <p className="text-gray-700 mb-6">
              We and our partners use cookies and similar technologies, including the Meta Pixel, to understand site usage, measure advertising performance, and deliver relevant marketing. You can control cookies through your browser settings. See our <a href="/cookie-policy" className="text-blue-600 hover:underline">Cookie Policy</a> for details.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Your Privacy Rights</h2>
            <p className="text-gray-700 mb-6">
              Depending on where you live, you may have the right to access, correct, delete, or receive a copy of your personal information, and to opt out of certain data sharing. You can unsubscribe from marketing emails at any time using the link in any email. California residents: Under the CCPA/CPRA you have the right to know what personal information we collect, request its deletion, opt out of the &quot;sale&quot; or &quot;sharing&quot; of personal information (including data shared with advertising partners such as Meta), and not be discriminated against for exercising these rights. To make a request, email <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Data Retention</h2>
            <p className="text-gray-700 mb-6">
              We retain your personal information for as long as your account is active or as needed to provide services, comply with legal obligations, resolve disputes, and enforce our agreements. You may request deletion at any time, subject to legal record-keeping requirements.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Contact</h2>
            <p className="text-gray-700 mb-6">
              For privacy-related questions or to exercise your rights, contact us at <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>.
            </p>

            <p className="text-gray-700 mt-8 font-medium">
              By using our site, you consent to this Privacy Policy.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
